import { TFunction } from "i18next";
import { InstantReply } from "../api/graphql";

export const InstantReplyType: Record<string, InstantReply> = {
  call_back_now: InstantReply.CallBackNow,
  call_back_two_minutes: InstantReply.CallBackTwoMinutes,
  call_back_five_minutes: InstantReply.CallBackFiveMinutes,
  cant_talk_now: InstantReply.CantTalkNow,
};

export default function getInstantReplyContent(
  t: TFunction,
  contentEnum: InstantReply
) {
  const lookup: Record<InstantReply, string> = {
    CALL_BACK_NOW: t("I'm free now, call me back."),
    CALL_BACK_TWO_MINUTES: t("Can you call back in 2 minutes?"),
    CALL_BACK_FIVE_MINUTES: t("Can you call back in 5 minutes?"),
    CANT_TALK_NOW: t("Sorry can't talk now."),
  };
  return lookup[contentEnum];
}
